import { translationMessages } from "./TranslationMessages.slice";

export const translationMessagesActions = { ...translationMessages.actions };
